<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">
    <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
    </div>

    <ng-container *ngIf="!isReadonlyValue">
        <div class='input-group'>
            <ng-content select="[before]"></ng-content>

            <input [(ngModel)]="phoneValue" type="text" [attr.name]="inputName" class="form-control"
                [ngClass]="{invalid: invalid}" [id]="controlId" (focusout)="touch()" [maskito]="phoneMaskOptions"
                [autocomplete]="autocomplete ? 'on' : 'turn-off'" [attr.maxlength]="maxlength"
                [attr.tabindex]="tabindex" [attr.placeholder]="placeholder" />

            <ng-content select="[after]"></ng-content>
        </div>
    </ng-container>
    <ng-container *ngIf="isReadonlyValue">
        <span class="readonly-value">{{value}}</span>
    </ng-container>

</form-control-container>
